"use client";

import { useEffect } from "react";
import { usePathname } from "next/navigation";

// Deze Next.js-versie scrolt bij een <Link>-navigatie alleen naar boven als
// zijn eigen heuristiek de nieuwe pagina als "niet zichtbaar" beoordeelt — bij
// een lange pagina (vrijwel elke hier) blijkt dat vaak fout te gaan, waardoor
// je bijv. na "Shop dames" midden op de nieuwe pagina belandt in plaats van
// bovenaan. Forceert daarom zelf altijd scroll naar boven bij een echte
// route-wissel (pathname-wijziging; querystring-only wijzigingen zoals
// filters raken dit niet).
export default function ScrollToTop() {
  const pathname = usePathname();

  useEffect(() => {
    // { behavior: "instant" } is bewust nodig: door de globale
    // `scroll-behavior: smooth` op <html> zou window.scrollTo(0, 0) anders
    // een langzame geanimeerde scroll starten in plaats van direct bovenaan
    // beginnen.
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
}
